import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { fleetMessageSchema } from '../schemas/fleet-message.schema';

/**
 * Assigns Place Sets to a given Vehicle Group
 * @param vehicleGroupId ID of the Vehicle Group being assigned to
 * @param assignmentPlaceSetIds IDs of Place Sets being assigned
 * @param unassignmentPlaceSetIds IDs of Place Sets being unassigned
 * @returns Array of IDs
 */
export function postVehicleGroupsIdPlaceSetsCombinedAssignment(
  this: unknown,
  vehicleGroupId: number,
  assignmentCustomPlaceSetIds: number[],
  unassignmentCustomPlaceSetIds: number[]
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        fleetEnvironment
          .resolve(this)
          .vehicleGroupsCustomPlaceSetsCombinedAssignmentUrl(vehicleGroupId),
        {
          method: 'POST',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
          body: JSON.stringify({
            assignmentCustomPlaceSetIds,
            unassignmentCustomPlaceSetIds,
          }),
        }
      )
    )
  ).pipe(
    selectData(
      fleetMessageSchema.extend({
        data: z.object({
          assigned: z.array(z.number()),
          unassigned: z.array(z.number()),
        }),
      })
    )
  );
}
